import { EVENT, APP_PAGE_ID } from "../../constants";

const buildParamsFromAppAndPlacement = (app, platform) => {
  const eventType = EVENT[app];
  const pageId = APP_PAGE_ID[app][platform];

  return {
    eventType,
    pageId
  };
};

export default buildParamsFromAppAndPlacement;
